<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 18 18"
  >
    <rect
      id="사각형_3732"
      data-name="사각형 3732"
      fill="#d34828"
      width="18"
      height="18"
      transform="translate(0 0)"
    />
    <g id="그룹_3753" data-name="그룹 3753" transform="translate(6.448 5.347)">
      <path
        id="패스_1817"
        data-name="패스 1817"
        fill="#fff"
        d="M-2168.562,4711.418H-2166c1.607,0,2.93.568,2.93,2.372,0,1.734-1.343,2.5-2.881,2.5h-.853v2.42h-1.754Zm2.519,3.489c.853,0,1.264-.4,1.264-1.117,0-.735-.471-.99-1.313-.99h-.715v2.107Z"
        transform="translate(2168.562 -4711.418)"
      />
    </g>
  </svg>
</template>
<script>
export default {
  props: {
    width: {
      type: Number,
      default: 18,
    },
    height: {
      type: Number,
      default: 18,
    },
  },
};
</script>
